import { createAction, props } from '@ngrx/store';

import { type CanvasElementId } from '@blaze-runtime/engine-domain';
import { type InputSchemaInfo } from '@blaze-shared/api-contracts-domain';
import { type RuntimeEventType } from '@blaze-shared/schema-domain';
import { type NamespaceId, type WorkflowNode } from '@blaze-shared/workflow-domain';

export const generateDeleteRowWorkflow = createAction(
  `[Workflows] Generate delete row workflow`,
  props<{ elementId: CanvasElementId; actionPath: string }>(),
);

export const createElementWorkflow = createAction(
  `[Workflows] Create element workflow`,
  props<{
    elementId: CanvasElementId;
    inputSchemas: InputSchemaInfo[];
    isLongRunningWf?: boolean;
    isServerWf?: boolean;
    name?: string;
    nodes?: WorkflowNode[];
    ns: NamespaceId;
    /** Path to the workflowId of the action */
    workflowIdPath: string | undefined;
    eventType?: RuntimeEventType;
  }>(),
);

export const createElementWorkflowFailed = createAction(
  `[Workflows] Create element workflow failed`,
  props<{ elementId: CanvasElementId; workflowIdPath: string | undefined }>(),
);

export const createElementWorkflowSuccess = createAction(
  `[Workflows] Create element workflow success`,
  props<{ elementId: CanvasElementId; workflowIdPath: string | undefined }>(),
);
